import { React, useEffect, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiZoomIn } from 'react-icons/fi';
import Moment from 'react-moment';

import api from '../../services/api';
import UserPermission from '../../components/UserPermission';
import './styles.css';
import Table from "../../components/Table";
import { Paper, Typography } from '@mui/material';
import Breadcrumbs from '../../components/Breadcrumbs';
import MultiManual from '../../components/Manual/MultiManual';

const classes = {
  paper: {
    overflow: 'auto',
    flexDirection: 'row',
    minWidth: '100%',
    padding: '30px',
    backgroundColor: '#F5F5F5',
    boxShadow: 'none',
    marginTop: 20
  },
}


export default function LateComplaints() {
  const navigate = useNavigate();

  // Permissão do usuário no sistema
  let userPermission = UserPermission();

  const [complaints, setComplaints] = useState([]);

  const columns = useMemo(
    () => [
      {
        Header: 'CÓDIGO',
        accessor: 'reference',
      },
      {
        Header: 'Data de Abertura',
        accessor: 'createdAt',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <Moment locale format={'DD/MM/YYYY'} >
                {value}
              </Moment>
            </>
          )
        }
      },
      {
        Header: 'Data de Previsão de Atendimento',
        accessor: 'datePrevision',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <Moment locale format={'DD/MM/YYYY'} >
                {value}
              </Moment>
            </>
          )
        }
      },
      {
        Header: 'Tipo',
        accessor: 'area',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <span>
                {value}
              </span>
            </>
          )
        }
      },
      {
        Header: 'Executor Responsável',
        accessor: 'nameExecutor',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <span>
                {value}
              </span>
            </>
          )
        }
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <span className={
                value === 'Resolvido' ? 'resolvido' :
                  value === 'Indeferido' ? 'indeferido' :
                    value === 'Novo' ? 'novo' :
                      'emAnalise'
              }
              >
                {value}
              </span>
            </>
          )
        }
      },
      {
        Header: 'Descrição',
        accessor: 'description',
        Cell: ({ cell: { value } }) => {
          return (
            <>
              <span>
                {value.length < 50 ? value : value.substr(0, 60) + "..."}
              </span>
            </>
          )
        }
      },
      {
        Header: () => null,
        id: 'edit',
        Cell: ({ row }) => (
          <div style={{ cursor: 'pointer' }} onClick={() => navigate(`/details/${row.original.id}`, { state: { from: [{ name: 'Ocorrências Atrasadas', href: '/no-location-complaints' }] } })}>
            <FiZoomIn
              size={20}
              color="#22543d"
            />
          </div>
        ),
      },
    ],
    []
  );

  /* Lista de items */
  useEffect(() => {
    /* Define o filtro da listagem de ocorrências */
    let filter = { order: 'datePrevision ASC', where: { and: [] } }

    /* Filtro das ocorrências */
    filter.where.and.push({ datePrevision: { lte: new Date() } });
    filter.where.and.push({
      or: [
        { status: 'Novo' },
        { status: 'Em análise' }
      ]
    });

    api.get(`${userPermission}/complaints?filter=${JSON.stringify(filter)}`).then(response => {
      /* Adiciona a propriedade nomeExecutor na lista de ocorrências */
      for (var i = 0; i < response.data.length - 1; i++) {
        response.data[i]["nameExecutor"] = ""
      }

      /* Se o usuário logado não for executor */
      if (userPermission !== 'executor') {
        const filterExecutor = { where: { role: 'Executor' } };

        /* Realiza o get dos usuários */
        api.get(`${userPermission}/users?filter=${JSON.stringify(filterExecutor)}`).then(res => {
          let nameExecutor = '';
          /* para cada ocorrência */
          response.data.forEach(input => {
            try {
              /* Obtem o nome do executor para cada ocorrência */
              nameExecutor = res.data.find(user => user.id === input.executorId);
              /* Adiciona o nome do executor */
              input.nameExecutor = nameExecutor.name;
            } catch (error) {
              input.nameExecutor = 'Sem executor';
            }
          });
          setComplaints(response.data);
        });
      } else {
        response.data.forEach(input => {
          input.nameExecutor = localStorage.getItem('NameUser');
        });

        setComplaints(response.data);
      }
    });
  }, [userPermission]);

  return (
    <div style={{ padding: 30 }}>
      <Breadcrumbs
        paths={[
          { href: '/search', name: 'Ocorrências' },
          { href: '', name: 'Ocorrências Atrasadas' },
        ]}
      />
      <Paper style={classes.paper} elevation={1}>
        <Typography variant="h5" align="center" style={{
          margin: 8,
          color: '#103168',
          fontWeight: 600,
          marginBottom: 30,
        }}>
          Ocorrências Atrasadas
        </Typography>

        <div
          style={{
            padding: 10,
            backgroundColor: '#FFFBE8',
            color: 'rgba(0,0,0,0.8)',
            borderRadius: 7,
            width: '100%'
          }}
        >
          <p>Digite abaixo o código da ocorrência que deseja filtrar.</p>
          Obs: Abaixo são listadas somentes ocorrências que estão com o atendimento atrasado.
        </div>

        <div id='late-list'>
          <Table columns={columns} data={complaints} />
        </div>

        <MultiManual
          components={[
            {
              id: 'table-occurrences-input',
              message: `Aqui você pode procurar uma ocorrência`,
              padding: 20
            },
            {
              id: 'late-list',
              message: `Aqui é a lista de ocorrências filtradas`,
              padding: 20,
            }
          ]}
        />
      </Paper >
    </div>
  );
};
